import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './vi-destination-items.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import ObjectSelector from 'scoreboard/components/object-selector'
import appDisplay from 'scoreboard/components/app-display'
import SelectDestinationMetricsDialog from './select-destination-metrics-dialog'
import spotlight from 'scoreboard/components/spotlight'
import globals from 'scoreboard/components/globals'
import TreeActions from 'scoreboard/components/tree-actions'
import { ALL_INITIATIVES } from 'scoreboard/initiatives/initiatives-gardener'
import SelectedItemInfo from './selected-item-info'
import projects from 'scoreboard/projects/projects'
import ScorecardNode from 'scoreboard/scorecards/scorecard-node'
import Tooltip from 'scoreboard/components/tooltip'

const ViDestinationItems = Backbone.View.extend({
	tagName: 'form',
	className: 'vi-wizard vi-destination-items',
	events: {
		'click .selected-items': 'viewSelectedItems',
		'click .cancel': 'close'
	},

	initialize: function (options) {
		this.options = options || {}
		this.destinationItems = this.options.model.get('destinationItems') || []
		// make a copy of the destination items for later comparison
		this.comparisonDestinationItems = _.clone(this.destinationItems)
		this.initializeFormView()
		this.initializeObjectSelector()
	},

	initializeFormView() {
		const MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: () => _.isNil(this.test())
		})
	},

	initializeObjectSelector() {
		// Intelligently guesses an org ID to pre-select in the object selector
		// default to current org
		let orgId = globals.orgId
		let projectId = projects.id		//this should match the globals

		// otherwise if the model provides the org when the import was created,
		// then use that
		let orgAtTimeOfCreation = this.model.get('destinationOrganization')
		if (orgAtTimeOfCreation) {
			orgId = orgAtTimeOfCreation.id
			projectId = orgAtTimeOfCreation.projectId
		}

		let section = this.model.get('type') === 'metric-value' ? 'scorecards' : 'initiatives'
		this.objectSelector = new ObjectSelector({
			orgId,
			projectId,
			section,
			showProjectSelector: true,
			allowAll: true // displays "All Initiatives" for initiative selector
		})
		this.objectSelector.on('selectOrg', this.selectOrg.bind(this))
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		this.$('.object-selector').replaceWith(this.objectSelector.el)
		this.objectSelector.render()

		this.setupTreeActions()
		this.renderSelectedItemInfo()
		this.formView.start()
		return this
	},

	renderSelectedItemInfo: function() {
		let selectedItemInfo = new SelectedItemInfo({
			type: this.model.get('type'),
			numSourceItems: this.numSourceItems(),
			numDestinationItems: this.destinationItems.length,
			showEditButton: true
		})
		// #57395 - for SelectedItemInfo, it appears that we need call render()
		// before replacing with the el, or it doesn't display on subsequent
		// calls to this method
		selectedItemInfo.render()
		this.$('.selected-item-info').replaceWith(selectedItemInfo.el)

	},

	numSourceItems: function() {
		// for saved imports, use the existing destinationMappingData to
		// to determine the number of unique source items
		let sourceNames = _.get(this.model.attributes, 'destinationMappingData.sourceNames')
		let numSourceItems
		if (_.isNil(sourceNames)) {
			// if there is no destinationMappingData, use the numSourceItems
			// populated when calling api/imports/validate-source-data
			numSourceItems = _.get(this.model.attributes, 'numSourceItems', 0)
		} else {
			numSourceItems = sourceNames.length
		}
		return numSourceItems
	},

	setupTreeActions: function() {
		this.treeActions = new TreeActions({
			el: this.objectSelector.objectGardener.tree.el.node(),
			tree: this.objectSelector.objectGardener.tree,
			buttonContent: i18n.get('common.add'),
			itemSelectable: (data) => {
				let node = new ScorecardNode(data)
				return !node.replicated() || node.transformedDocking()
			},
			disabledClickTooltip: (target, data) => {
				_.invoke(this.disabledMessageTooltip, 'remove')
				this.disabledMessageTooltip = new Tooltip({
					attachTo: target,
					content: i18n.get('admin.import.metricValue.cannotUpdateReplicatedNode', data.id)
				}).render()
			}
		}).render()
		this.treeActions.on('selected', () => this.select())
	},

	context: function () {
		let type = this.model.get('type')
		let pluralKey, instructionKey
		if (type === 'initiative-status') {
			pluralKey = 'initiatives.initiatives'
			instructionKey = 'admin.import.destinationItems.instructions.initiative'
		} else {
			pluralKey = 'scorecards.metrics.metrics'
			instructionKey = 'admin.import.destinationItems.instructions.metric'
		}
		let pluralItem = i18n.get(pluralKey)
		let instructions = i18n.get(instructionKey)
		return {
			title: i18n.get('admin.import.destinationItems', pluralItem),
			label: i18n.get('admin.import.selectItems', pluralItem),
			instructions
		}
	},

	saveState: function() {
		// #32198 don't include "All Initiatives" item in submit data
		let destinationItems = _.filter(this.destinationItems, item =>
			item.id != 'all-items')
		this.model.set('destinationItems', destinationItems)
		this.model.set('destinationIds', _.map(destinationItems, 'id'))
	},

	// when the user selects on a scorecard node
	select: function() {
		this.formView.change()
		this.formView.clearErrors()
		let treeItem = this.objectSelector.objectGardener.tree._selected
		this.orgLabel = _.get(this.objectSelector.orgGardener.tree.selected(), 'label')
		// #30826 add "all initiatives"
		if (treeItem.id === ALL_INITIATIVES) {
			this.addAllInitiativeItems()
		} else {
			this.addChildrenOfSelectedItem(treeItem)
		}
		this.treeActions.applyCheckmark()
		this.renderSelectedItemInfo()
		// always spotlight the button so it's clear where to look after
		// clicking on something in the tree
		// process.nextTick() is needed for the spotlight to fade back out
		// and not get stuck in the highlighted state
		process.nextTick(() => spotlight(this.$('.selected-items')))
	},

	selectOrg(org) {
		this.formView.change()
		this.model.set('destinationOrganization', {id: org.id})
		this.setupTreeActions()
	},

	addChildrenOfSelectedItem: function(treeItem) {
		let item = this.objectSelector.objectGardener.tree.get(treeItem.id)
		let importType = this.model.get('type')
		let addItem = true
		if (importType === 'metric-value' && item.type != 'metric') {
			addItem = false
		}
		// #35619 don't add archived initiatives
		if (importType === 'initiative-status' && !item.visible) {
			addItem = false
		}
		if (addItem) {
			this.addItem(item)
		}
		let children = treeItem._allChildren
		_.each(children, item => {
			this.addChildrenOfSelectedItem(item)
		})
	},

	addItem: function (item) {
		item.organization = {label: this.orgLabel}
		if (!_.some(this.destinationItems, {id: item.id})) {
			this.destinationItems.push(item)
		}
	},

	addAllInitiativeItems: function () {
		let allItems = this.objectSelector.objectGardener.tree.nodes
		_.each(allItems, item => {
			// don't add the  "All Initiatives" item
			// #32198 the "All Initiatives" item has an id of 'all-items'
			// #35619 don't add archived initiatives
			if (!_.isNil(item) && item.id != 'all-items' && item.visible) {
				this.addItem(item)
			}
		})
	},

	test: function() {
		const problem = FormView.prototype.test.apply(this, arguments)
		if (problem) {
			return problem
		}

		if (_.isEmpty(this.destinationItems)) {
			return i18n.get('common.select.required')
		}
	},

	viewSelectedItems: function() {
		const createView = (destinationItems) => {
			let selectDestinationMetrics = new SelectDestinationMetricsDialog({
				destinationItems,
				numSourceItems: this.numSourceItems(),
				type: this.model.get('type')
			})

			selectDestinationMetrics.once('done', data => {
				this.formView.change()
				this.destinationItems = data.destinationItems
				// update the "comparisonDestinationItems" after closing the dialog
				this.comparisonDestinationItems = _.clone(this.destinationItems)
				this.renderSelectedItemInfo()
				// if no destination items are selected (whether from
				// deselecting individually, or by "Remove All"
				// re-enable all items in the tree (#32539)
				if (_.isEmpty(data.destinationItems)) {
					this.clearSelectedTreeItems()
				}
			})

			selectDestinationMetrics.on('change', id => {
				this.treeActions.removeCheckmark(id)
				// re-enable "All Initiatives" after any item deletion
				this.treeActions.removeCheckmark(ALL_INITIATIVES)
			})

			return selectDestinationMetrics
		}
		// #32698 change order that Destination KPIs are listed
		// If no changes have been made, display the existing destination items
		// (they will already be ordered)
		if (_.isEqual(this.destinationItems, this.comparisonDestinationItems)) {
			appDisplay.dialog(createView(this.destinationItems))
		} else {
			// If there has been a change to the destination items due to adding
			// items from the object selector, retrieve the correctly ordered
			// destination items
			this.saveState()
			let promise = $.ajax({
				url: 'api/imports/destination-items',
				data: JSON.stringify(this.model),
				method: 'post'
			})
			appDisplay.dialog(promise, destinationItems => {
				return createView(destinationItems)
			})
			this.xhr = promise
		}
	},

	clearSelectedTreeItems: function () {
		Object.keys(this.treeActions.tree.nodes).forEach((id) => {
			this.treeActions.removeCheckmark(id)
		})
	},

	close: function() {
		_.invoke(this.xhr, 'abort')
	},

	submit: function () {
		this.saveState()
		return $.ajax({
			method: 'post',
			data: JSON.stringify(this.model),
			url: 'api/imports/destination-mapping-data',
			success: destinationMappingData => {
				this.model.set('destinationMappingData', destinationMappingData)
				this.options.wizard.next()
			},
			error: (xhr) => {
				let errors = xhr.responseJSON ? xhr.responseJSON.errors : false // validation errors
				if (errors) {
					let messages = _.map(errors, 'message')
					this.formView.errorMessages(messages)
				} else { // other types of errors
					this.formView.error(xhr)
				}
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.objectSelector, this.treeActions, this.disabledMessageTooltip], 'remove')
	}

})

export default ViDestinationItems
ViDestinationItems.__filename__ = 'imports/vi/vi-destination-items.js'
